import Axios from "axios";
import { cityAttractionsConstants } from "../constants/CityAttractionsConstants";

import { setTokens } from "../helpers/auth-header";
import { authHeader } from "../helpers/auth-header";
var url = process.env.REACT_APP_URL || "http://localhost:8080/";

export const cityAttractionsService = {
	
	search,
	createarticle,
	createallarticles
	

};


async function search(dispatch ,city) {
	
	dispatch(request());
	
	//var token = authHeader()
	Axios.get(`${url}api/amadeus/` + city, 
		{ validateStatus: () => true })
		.then((res) => {
			if (res.status === 200) {
				dispatch(success(res.data));
			} else if (res.status === 215) {
				dispatch(failure(res.data.response));}
				else if (res.status === 402) {
					dispatch(failure("Error"));
			
			}else{
				
				dispatch(failure("Error"));
			}
		})
		.catch((err) =>{		
				dispatch(failure(err));
			})

	function request() {
		
		return { type: cityAttractionsConstants.SEARCH_REQUEST };
	}
	function success(data) {
		console.log(data)
		return { type: cityAttractionsConstants.SEARCH_SUCCESS , data};
	}
	function failure(error) {
		console.log(error)
		return { type: cityAttractionsConstants.SEARCH_FAILURE, error };
	}
}





async function createarticle(dispatch ,word) {
	
	dispatch(request());
	
	var data={
		keyword: word
	}
	//var token = authHeader()
	Axios.post(`https://hopguides-chatgpt-main-j7limbsbmq-oc.a.run.app/seo` , data, 
		{ validateStatus: () => true })
		.then((res) => {
			if (res.status === 200) {
				dispatch(success(res.data));
			} else if (res.status === 215) {
				dispatch(failure(res.data.response));}
				else if (res.status === 402) {
					dispatch(failure("Error"));
			
			}else{
				
				dispatch(failure("Error"));
			}
		})
		.catch((err) =>{		
				dispatch(failure(err));
			})

	function request() {
		
		return { type: cityAttractionsConstants.ARICLE_REQUEST };
	}
	function success(data) {
		console.log(data)
		return { type: cityAttractionsConstants.ARICLE_SUCCESS , data};
	}
	function failure(error) {
		console.log(error)
		return { type: cityAttractionsConstants.ARICLE_FAILURE, error };
	}
}




async function createallarticles(dispatch ) {
	
	dispatch(request());
	
	//var token = authHeader()
	Axios.get(`https://hopguides-chatgpt-main-j7limbsbmq-oc.a.run.app/trigger-zap` , 
		{ validateStatus: () => true })
		.then((res) => {
			if (res.status === 200) {
				dispatch(success(res.data));
			} else if (res.status === 215) {
				dispatch(failure(res.data.response));}
				else if (res.status === 402) {
					dispatch(failure("Error"));
			
			}else{
				
				dispatch(failure("Error"));
			}
		})
		.catch((err) =>{		
				dispatch(failure(err));
			})

	function request() {
		
		return { type: cityAttractionsConstants.ARICLE_REQUEST };
	}
	function success(data) {
		console.log(data)
		return { type: cityAttractionsConstants.ARICLE_SUCCESS , data};
	}
	function failure(error) {
		console.log(error)
		return { type: cityAttractionsConstants.ARICLE_FAILURE, error };
	}
}

